import { alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to bottom, ${color1}, ${color2})`;
}

const OBSIDIAN = '#0B0F19';
const CARD = '#151921';
const ICE = '#F3F4F6';
const SLATE = '#9CA3AF';
const ACCENT = '#3F90DF';

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: SLATE,
  600: '#6B7280',
  700: '#454F5B',
  800: ICE,
  900: OBSIDIAN,
  500_8: alpha(SLATE, 0.08),
  500_12: alpha(SLATE, 0.12),
  500_16: alpha(SLATE, 0.16),
  500_24: alpha(SLATE, 0.24),
  500_32: alpha(SLATE, 0.32),
  500_48: alpha(SLATE, 0.48),
  500_56: alpha(SLATE, 0.56),
  500_80: alpha(SLATE, 0.8)
};

const PRIMARY = {
  lighter: '#D6E8FA',
  light: '#6AABEA',
  main: process.env.REACT_APP_PRIMARY || ACCENT,
  dark: process.env.REACT_APP_HOVER || '#2C6FB0',
  darker: '#1E4E80',
  contrastText: OBSIDIAN,
  sidebar: process.env.REACT_APP_SIDEBAR || CARD,
  mainSidebarColor: process.env.REACT_APP_BASE_COLOR || OBSIDIAN
};
const JOBSCROLL = {
  white: ICE,
  light: CARD,
  main: SLATE,
  dark: OBSIDIAN,
  darker: ''
};
const SECONDARY = {
  lighter: '#C5D8F0',
  light: '#6AABEA',
  main: ACCENT,
  dark: '#2C6FB0',
  darker: '#1E4E80',
  contrastText: ICE
};
const INFO = {
  lighter: '#D6E8FA',
  light: '#6AABEA',
  main: ACCENT,
  dark: '#2C6FB0',
  darker: '#1E4E80',
  contrastText: ICE
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#34D399',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: OBSIDIAN
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: OBSIDIAN
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#F87171',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: ICE
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main)
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  blue: [ACCENT, '#6AABEA', '#A5F3FF', '#CCFAFF'],
  green: ['#34D399', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#F87171', '#FF8F6D', '#FFBD98', '#FFF2D4']
};

const palette = {
  common: { black: '#000', white: ICE },
  primary: { ...PRIMARY },
  jobscroll: { ...JOBSCROLL },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,

  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: 'rgba(243, 244, 246, 0.08)',
  text: { primary: ICE, secondary: SLATE, disabled: '#6B7280', inactive: SLATE },
  background: { paper: CARD, default: OBSIDIAN, neutral: '#1C2430' },
  drawerBackground: PRIMARY.sidebar,
  action: {
    active: SLATE,
    hover: GREY[500_8],
    selected: alpha(ACCENT, 0.16),
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48
  }
};

export default palette;
